import * as THREE from 'three';

// ============================================================
// Reusable MeshBasicMaterial pool — avoids per-particle alloc
// ============================================================

class MaterialPool {
  private readonly free: THREE.MeshBasicMaterial[] = [];

  constructor(initialSize = 100) {
    for (let i = 0; i < initialSize; i++) {
      this.free.push(this.create());
    }
  }

  acquire(): THREE.MeshBasicMaterial {
    const mat = this.free.pop() ?? this.create();
    mat.opacity = 1;
    mat.color.set(0xffffff);
    mat.visible = true;
    return mat;
  }

  release(mat: THREE.MeshBasicMaterial): void {
    this.free.push(mat);
  }

  private create(): THREE.MeshBasicMaterial {
    return new THREE.MeshBasicMaterial({
      transparent: true,
      depthWrite: false,
    });
  }
}

export const materialPool = new MaterialPool();
